import React from "react";
import TrainingPreferences from "@/components/TrainingPreferences/TrainingPreferences";

const TrainingPreferencesPage: React.FC = () => {
  return <TrainingPreferences />;
};

export default TrainingPreferencesPage;
